import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'AddPaymentForm' | 'EditPaymentForm' | 'RemoveCardModal' | 'CVVChallenge';

/**
 * Errors related to the Credit Cards page
 */
export const Errors = createErrors<Page, Component>('CreditCards')({
    AddPaymentForm: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to add credit card',
        },
    },
    EditPaymentForm: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to edit credit card',
        },
    },
    RemoveCardModal: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to remove credit card',
        },
    },
    CVVChallenge: {
        FetchAttemptCountFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch CVV validation attempt count',
        },
        ValidateCvvFailed: {
            severity: 'HIGH',
            message: 'Failed to validate credit card CVV',
        },
        InitializeAdyenFailed: {
            severity: 'HIGH',
            message: 'Failed to initialize Adyen stored card CVC field',
        },
    },
});
